/**
 * list item component (row in list view)
 *
 * Properties:
 *
 *      id:                 string, id of list item send to
 *      listStyle:          string, type defines how items are rendered (tight or standard)
 *      elements:           array, array of objects containing data and attributes for list item elements (columns)
 *      menu:               array, array of objects containing menu entries for burger menu (optional)
 *                              ref:        string, hyper link for menu entry (should be # if callback has to be used)
 *                              name:       string, name to display in menu
 *                              title:      string, info for entry
 *                              icon:       string, class name of icon to be positioned in front of menu entry
 *                              value:      string, value to be used as parameter in handler callback to identify menu entry
 *
 *      menuHandler:        function, callback to triggered by menu entries if ref is #,
 *                                usually this is the handler of list view to execute navigation or remove a list item
 *      panels:             array, array of objects containing data of panels (e.g. details)
 */
import ListItemElement from "./ListItemElement";
import OrderReservations from "../pages/reservations/components/OrderReservations";
import Checkins from "../pages/reservations/components/Checkins";
import { CheckinsProgressBar } from "../pages/reservations/components/CheckinsProgressBar";
import Resources from "../pages/contingents/components/Resources";
import ResourcesPanel from "../pages/contingents/components/ResourcesPanel";
import InsuranceCertificates from "../pages/finances/components/InsuranceCertificates";
import InsuranceCertificatesPanel from "../pages/finances/components/InsuranceCertificatesPanel";
import DropdownMenu from "./DropdownMenu";
import Transactions from "../pages/finances/components/Transactions";
import TransactionsPanel from "../pages/finances/components/TransactionsPanel";
import InvoiceItems from "../pages/invoices/components/InvoiceItems";
import { InvoiceProgressBar } from "../pages/invoices/components/InvoicePanel";
import HelpMessageItems from "../pages/helpMessages/components/HelpMessageItems";
import HelpMessageItemsPanel from "../pages/helpMessages/components/HelpMessageItemsPanel";
//import ContingentPlansListItemAddition
//    from "../pages/contingents/contingentPlans/ui_components/contingentPlansListItemAddition";
//import ContingentPlansPanel from "../pages/contingents/contingentPlans/components/contingentPlansPanel";
type DataType = {
  app_user_role: string;
  dispatch: any;
  checkout: boolean;
  setCheckout: any;
  setCheckoutReservation: any;
  setCheckoutCheckin: any;
  setFilter: any;
  filter: any;
  setNKey: any;
  sort: any;
  setSort: any;
  _key: string;
  locations: any;
};
const ListItem = (props: any) => {
  let _class: string = props.listStyle === "standard" ? "inb-c-item" : "inb-c-item-details-row row";
  if (typeof props.extraClasses !== "undefined") {
    _class += " " + props.extraClasses;
  }
  if (typeof props.overwriteClasses !== "undefined") {
    _class = props.overwriteClasses;
  }
  let extra: boolean = false;
  if (typeof props.extra !== "undefined") {
    extra = props.extra;
  }
  let extra2: boolean = false;
  if (typeof props.extra2 !== "undefined") {
    extra2 = props.extra2;
  }
  let extra3: boolean = false;
  if (typeof props.extra3 !== "undefined") {
    extra3 = props.extra3;
  }
  let extra4: boolean = false;
  if (typeof props.extra4 !== "undefined") {
    extra4 = props.extra4;
  }
  let extra5: boolean = false;
  if (typeof props.extra5 !== "undefined") {
    extra5 = props.extra5;
  }
  let extra6: boolean = false;
  if (typeof props.extra6 !== "undefined") {
    extra6 = props.extra6;
  }
  let extra8: boolean = false;
  if (typeof props.extra8 !== "undefined") {
    extra8 = props.extra8;
  }
  let extra9: boolean = false;
  if (typeof props.extra9 !== "undefined") {
    extra9 = props.extra9;
  }
  let locations: any = typeof props.locations !== "undefined" ? props.locations : null;

  let data: DataType = {
    app_user_role: props.app_user_role,
    dispatch: props.dispatch,
    checkout: props.checkout,
    setCheckout: props.setCheckout,
    setCheckoutReservation: props.setCheckoutReservation,
    setCheckoutCheckin: props.setCheckoutCheckin,
    setFilter: props.setFilter,
    filter: props.filter,
    setNKey: props.setNKey,
    sort: props.sort,
    setSort: props.setSort,
    _key: props._key,
    locations: locations,
  };
  return (
    <div
      id={props.id}
      className={_class}
      style={props.listStyle === "standard" ? {} : { paddingRight: 0, marginTop: "0.75%" }}
    >
      {
        typeof props.menu !== "undefined" && props.menu !== null && (
          <DropdownMenu
            menu={props.menu}
            extra={extra}
            extra2={extra2}
            extra3={extra3}
            extra4={extra4}
            extra5={extra5}
            extra6={extra6}
            extra8={extra8}
            extra9={extra9}
            toggleElement={props.toggleElement}
            order={props.order}
            reservation={props.reservation}
            invoice={props.invoice}
            contingent={props.contingent}
            contingentPlan={props.contingentPlan}
            insurance={props.insurance}
            helpMessage={props.helpMessage}
            wallet={props.wallet}
            length={props.length}
            panels={props.panels}
            id={props.id}
            info={props.info}
          />
        )
        /*<aside>
                    <>
                        <aside className="inb-c-item__actions">
                            <DropdownButton id="dropdown-basic-button" title="..." drop="right" menuAlign="right"
                                            bsPrefix="button round inb-toggle-contingent-dd hover">
                                <ul className="inb-dropdown__list">
                                {props.menu.length > 0 && props.menu.map((obj,index) => {
                                return (
                                    <>
                                    <li data-inb-action-link={obj.title} id={"kln_"+index}>
                                        {typeof obj.clickHandler !== 'undefined'?<Dropdown.Item href={obj.href} onClick={() => obj.clickHandler(obj.changeLog)}>
                                            <i className={obj.iconClass}> </i>
                                            {obj.text}
                                        </Dropdown.Item> :<Dropdown.Item href={obj.href}>
                                            <i className={obj.iconClass}> </i>
                                            {obj.text}
                                        </Dropdown.Item>}
                                    </li>
                                    </>
                                );
                                    })
                                }
                                </ul>
                            </DropdownButton>
                            {extra && <button className={"button round inb-toggle-details inb-toggle-details-"+Biscuit.get('user.client_id')} type="button"
                                              title={t('toggle_${a}',{a:t('reservations')}, 'capital') }
                                              data-inb-toggle={"pricetariffs-panel-"+props.order.id}
                                              onClick={(e) => props.toggleElement(e,props.order.id)}
                                              id={"btn_pt_"+props.order.id}
                            >
                                <i className="fi fi-list-thumbnails"> </i>
                                {props.length >= 1 &&
                                <div className="badge primary reservations-count">
                                    { props.length }
                                </div>
                                }
                            </button>}
                            {extra2 && <button className={"button round inb-toggle-details inb-toggle-details-"+Biscuit.get('user.client_id')} type="button"
                                title={t('toggle_${a}',{a:t('checkins')}, 'capital') }
                                data-inb-toggle={"pricetariffs-panel-"+props.reservation.id}
                                onClick={(e) => props.toggleElement(e,props.reservation.id)}
                                id={"btn_pt_"+props.reservation.id}
                                >
                                <i className="fi fi-list-thumbnails"> </i>
                            {props.length >= 1 &&
                                <div className="badge primary reservations-count">
                            { props.length }
                                </div>
                            }
                                </button>}
                           {/!* {extra3 && typeof props.contingent.resourcetype_id !== 'undefined' && props.contingent.resourcetype_id < 4 &&
                                <>
                                <button className="button round inb-toggle-details inb-toggle-details>" type="button" title={t('toggle_${a}',{a:t('contingents')}, 'capital') } data-inb-toggle={'resources-panel-'+props.id}>
                                <i className="fi fi-list-thumbnails"></i>
                                    {typeof props.contingent.resources !== 'undefined' && props.contingent.resources.length >= 1 &&
                                <div className="badge primary reservations-count">
                                    {props.contingent.resources.length}
                                </div>
                                 }
                                </button>
                                </>
                                 }*!/}
                           { extra3 && <button className={"button round inb-toggle-details inb-toggle-details"} type="button"
                                              title={t('toggle_${a}',{a:t('resources')}, 'capital') }
                                              data-inb-toggle={"resources-panel-"+props.contingent.id}
                                              onClick={(e) => props.toggleElement(e,props.contingent.id)}
                                              id={"btn_pt_"+props.contingent.id}
                            >
                                <i className="fi fi-list-thumbnails"> </i>
                                {props.contingent.resources.length >= 1 &&
                                    <div className="badge primary reservations-count">
                                        { props.contingent.resources.length }
                                    </div>
                                }
                            </button>}
                        </aside>
                    </>
                    { typeof props.panels !== 'undefined' && props.panels.length > 0 &&
                        <button className="button round"><i className="fi fi-list-thumbnails"> </i></button>
                    }
                </aside>*/
      }

      {props.elements.map((element: any, index: any) => {
        if (typeof element.data === "undefined") {
          return null;
        }
        return (
          <ListItemElement
            key={"list-item-" + props.id + "-" + index}
            id={props.id}
            _key={props._key}
            type={element.type}
            value={element.value}
            title={element.title}
            data={element.data}
            handler={element.handler}
            mediumWidth={element.mediumWidth}
            smallWidth={element.smallWidth}
            largeWidth={element.largeWidth}
            extraTopClasses={element.extraTopClasses}
            style={element.style}
            extraData={typeof element.extraData !== "undefined" ? element.extraData : null}
            extraText={typeof element.extraText !== "undefined" ? element.extraText : null}
            badge={typeof element.badge !== "undefined" ? element.badge : false}
            listenPending={typeof element.listenPending !== "undefined" ? element.listenTo : false}
            itemPending={props.itemPending}
          />
        );
      })}
      {props.listStyle === "standard" &&
        typeof props.panels !== "undefined" &&
        props.panels !== null &&
        props.panels.length > 0 && <div className="inb-c-item-details"> </div>}
      {typeof props.orderReservation !== "undefined" && props.orderReservation && (
        <OrderReservations
          order={props.order}
          locations={props.locations}
          _exchangeLabel={props._exchangeLabel}
          setCheckout={props.setCheckout}
          dispatch={props.dispatch}
          refLink={props.refLink}
          app_user_role={props.app_user_role}
          checkout={props.checkout}
          setCheckoutReservation={props.setCheckoutReservation}
          setCheckoutCheckin={props.setCheckoutCheckin}
          setFilter={props.setFilter}
          filter={props.filter}
          setNKey={props.setNKey}
          sort={props.sort}
          setSort={props.setSort}
          _key={props._key}
          showNotification={props.showNotification}
        />
      )}
      {extra2 && (
        <>
          <Checkins reservation={props.reservation} data={data} panel={true} />
          <CheckinsProgressBar
            hasCompletedCheckouts={props.hasCompletedCheckouts}
            hasFutureCheckout={props.hasFutureCheckout}
            hasFutureCheckin={props.hasFutureCheckin}
            _exchangeLabel={props._exchangeLabel}
            hasValidCheckin={props.hasValidCheckin}
          />
        </>
      )}
      {/* {extra2 &&
                <>
                    <Checkins
                        reservation={props.reservation}
                        data={data}
                        panel={true}
                    />
                    <CheckinsProgressBar
                        hasCompletedCheckouts={props.hasCompletedCheckouts}
                        _exchangeLabel={props._exchangeLabel}
                        hasValidCheckin={props.hasValidCheckin}
                    />
                </>
            }*/}
      {extra3 && (
        <>
          <Resources contingent={props.contingent} data={data} panel={true} />
          <ResourcesPanel contingent={props.contingent} />
        </>
      )}
      {extra4 && (
        <>
          <InsuranceCertificates insurance={props.insurance} data={data} panel={true} />
          <InsuranceCertificatesPanel insurance={props.insurance} />
        </>
      )}
      {extra5 && (
        <>
          <Transactions wallet={props.wallet} data={data} panel={true} id={props.id} />
          <TransactionsPanel wallet={props.wallet} />
        </>
      )}

      {extra6 && (
        <>
          {/*<ContingentPlansListItemAddition
                    contingentPlan={props.contingentPlan}
                    setContingentPlan={props.setContingentPlan}
                    dispatch={props.dispatch}
                    data={data}
                    panel={false}
                    id={props.id}
                />
                <ContingentPlansPanel
                    contingentPlan={props.contingentPlan}
                />*/}
        </>
      )}
      {extra8 && (
        <>
          <InvoiceItems invoice={props.invoice} data={data} panel={true} />
          <InvoiceProgressBar invoice={props.invoice} />
        </>
      )}
      {extra9 && (
        <>
          <HelpMessageItems helpMessage={props.helpMessage} data={data} panel={true} />
          <HelpMessageItemsPanel helpMessage={props.helpMessage} />
        </>
      )}
    </div>
  );
};
export default ListItem;
